module.exports = MaterialUI.Collapse;